



















import {CodebookModel, PartyModel, ProductModel, StateOfCapitalModel, TransactionModel} from '@/libs/Api';
import {Component, Vue, Prop, Watch, Ref} from 'vue-property-decorator';
import { CrudAction } from '@/libs/core/crud/crud-action';
import { createCrudQueryPayload } from '@/libs/core/crud/crud-query';
import { CrudGetter } from '@/libs/core/crud/crud-getter';

import { stateOfCapitalStore } from '@/libs/state-of-capital/+state/store';
import CrudTable from '@/libs/common/components/CrudTable.vue';
import { Guid } from '@/libs/common/functions/guid';
import { Constants } from '@/libs/constants/constants';
import { codebooksStore } from '@/libs/codebooks/+state/store';
import {productsStore} from "@/libs/products/+state/store";

@Component({
	computed: {
		Constants() {
			return Constants
		}
	},
    components: {
        CrudTable
    }
})
export default class ProductReOpportunitiesGeneral extends Vue {

	firstLoad = true;

	get pending(): boolean {
		const pending = codebooksStore.useGetter(CrudGetter.Pending);
		if (!pending) {
			this.firstLoad = false;
		}
		return pending;
	}

	get codebooks(): any {
		return codebooksStore.useGetter(CrudGetter.Data);
	}

	get product(): ProductModel {
		return {...productsStore.useGetter(CrudGetter.Detail, Constants.ReOpportunitiesId)};
	}

	get savingProduct(): boolean {
		return productsStore.useGetter(CrudGetter.Saving, Constants.ReOpportunitiesId);
	}

	mounted() {
		this.getCodebooks();
		this.getProduct();
	}

	getProduct() {
		productsStore.dispatch(CrudAction.Get, { id: Constants.ReOpportunitiesId, key: Constants.ReOpportunitiesId });
	}

	saveProduct() {
		productsStore.dispatch(CrudAction.Update, { item: this.product, key: Constants.ReOpportunitiesId });
	}

	getCodebooks() {
		codebooksStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<CodebookModel>({
			field: 'name',
			order: 'asc'
		}));
	}
    
}
